// useWindowWidth.ts

import { useState, useEffect } from "react";

export default function useWindowWidth() {
    const [width, setWidth] = useState(() => window.innerWidth);

    useEffect(() => {
        const onResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    console.log("width", width);
    return width;
}
